import FactureFormController from './facture.form.controller';

export default {
    template: require('./facture.form.tpl.html'),
    controller: FactureFormController
};
